module.exports = __webpack_public_path__ + "img/login_biaoti4.b2baca5e.png";